import { z } from "zod";
import { mapErrorsToFields } from "../../../utils";
import AuthService from "../../../services/AuthService";
import { Axios, AxiosError } from "axios";

export type State = {
  errors?: {
    code?: string[];
    email?: string[];
    general?: string[];
  };
  success?: boolean;
  error?: {
    message: string;
    code: string;
  };
  defaultValues?: {
    email: string;
    code: string;
  };
};
const FormSchema = z.object({
  email: z.email({
    error: "Email is not valid",
  }),
  code: z
    .string({
      error: "Please enter code.",
    })
    .length(6, { message: "Code must be equal 6 characters" }),
});
const api = new AuthService();
export async function verifyEmail(
  prevState: State | undefined,
  data: FormData
): Promise<State> {
  const defaultValues = {
    email: data.get("email")?.toString() || "",
    code: data.get("code")?.toString().trim() || "",
  };

  const result = FormSchema.safeParse(defaultValues);
  if (!result.success) {
    const errors = mapErrorsToFields(result.error);
    return { ...prevState, errors, error: undefined };
  }

  try {
    const response = await api.verifyEmail({
      email: data.get("email") as string,
      code: data.get("code") as string,
    });
    const success = response.status === 200;
    if (success)
      return {
        errors: {},
        defaultValues: defaultValues,
        error: undefined,
        success: success,
      };
     
  } catch (ex: AxiosError | any) {
    console.log({ex});
    return {
        errors: {},
        defaultValues: defaultValues,
        error: {
          message: ex.response.data.description,
          code: ex.response.data.code,
        },
        success: false,
      };
  }

  return {
   errors: {},
    defaultValues: defaultValues,
    error: {
      message: "Failed to verify email.",
      code: "EmailVerification.error",
    },
    success: false,
  };
}
